module.exports = __webpack_public_path__ + "img/icon_edit.e42df296.png";